import { query, selectDilDefinitionByName } from 'srs-middleware';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useEffect, useState } from 'react';

/**
 * Hook to fetch data from
 */
export function useFetchRootResult(
	selectedDefinitionName: string,
	refreshTime: number | string | Date,
	rootResultFilter
) {
	const [result, setResult] = useState(null);

	// fires only on selectedDefinition change
	const { data, loading, error } = useAsyncCallback(async () => {
		if (!selectedDefinitionName) return;

		// returns the Result, basically we need the result id
		return await query(selectDilDefinitionByName(selectedDefinitionName), rootResultFilter ?? {});
	}, [selectedDefinitionName, refreshTime]);

	useEffect(() => {
		if (data) {
			setResult(data);
		}
	}, [data]);

	return {
		rootResult: result,
		loading,
		error,
	};
}
